import React from 'react';
import api from './api';
import CustomDataTable from './CustomDataTable'; // update path as needed
import AuthContext from '../context/AuthProvider';
import { canDo, isSuper } from '../utils/canDo';
import { FaEdit, FaPlus, FaMinus, FaTrash, FaThumbsUp, FaStar } from "react-icons/fa";
import SafeImage from './SafeImage';

import "./Doctors.css";
import "./TherapistDashboard.css";

class Inventory extends React.Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      services: [],
      inventoryFilter: "ALL", // ALL | LOW_STOCK | PO_RAISED
      issuedInventory: [],
      suggestedServices: [],
      modRows: [],
      selectedRows: [],
      showAdjustModal: false,
      adjustItem: null,
      adjustType: null,
      adjustQty: '',
      adjustRemarks: '',
      returnDate: "",
      etaDate:"",
      activeTab:"ReRoot",
      name: "",
      number: 0,
      filters: {
        name: '',
        description: '',
        amount: '',
        qty: '',
        remarks: ''
      },
      branches: [],
      orgs: [],
      showModal: false,
      isEditMode: false,
      editServiceId: null,
      users: [],
      newService: {
        name: '',
        description: '',
        amount: '',
        qty: 1,
        remarks: '',
        branch: 'selectB',
        org: 'selectOrg',
        igst: 0,
        cgst: 0,
        sgst: 0,
        ecess: 0,
        minQtyAlert: 3,
        hsn: '',          // 🆕 Added HSN
        image: null       // 🆕 Added image upload
      },
      isInventoryItem: true, // 🆕 Added to state
      uploadingImage: false,
    };
  }

  componentDidMount() {
    this.fetchServices("ReRoot");
    this.fetchIssuedInventory();
    this.getStaff();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.patientCard !== this.props.patientCard ||
      prevProps.filterT !== this.props.filterT
    ) {
      this.fetchServices("ReRoot");
      this.fetchIssuedInventory();
    }
  }
  
  getStaff = () => {
    api.get(`${process.env.REACT_APP_URL}/users/staff/all?_=${new Date().getTime()}`)
      .then((res) => 
              this.setState({ users: res.data}))
      .catch((err) => console.error('Error fetching Staff:', err));
  }

  fetchServices = (org) => {
    const { patientCard, filterT } = this.props;
    let endpoint = org;
 
    if (patientCard) {
      endpoint += `/${patientCard}/type/${filterT}`;
    }

    api.get(`${process.env.REACT_APP_URL}/services/inventory/${endpoint}?_=${new Date().getTime()}`)
      .then(response => {
        // Check if GDrive is disconnected (images won't load)
        if (response.headers?.['x-gdrive-status'] === 'disconnected') {
          window.dispatchEvent(new CustomEvent('gdrive-disconnected'));
        }
        this.getBranches();
        if (patientCard) {
          const data = response.data || [];
          const preselected = data.filter(row => row.parentId && row.parentId !== '');
          this.setState({ suggestedServices: data, modRows: [], selectedRows: preselected, newService: {} });
        } else {
          this.setState({ services: response.data || [], newService: {} });
        }
        this.setState({
          adjustItem: null,
          adjustType: null,
          adjustQty: '',
          adjustRemarks: '',
          inventoryFilter: "ALL",
        })
      })
      .catch(() => {
        alert('Error fetching services');
      });
  };

  fetchIssuedInventory = async () => {
  try {
    this.setState({ loading: true });

    const response = await api.get(`${process.env.REACT_APP_URL}/services/issuedInventory?_=${new Date().getTime()}`);
    const data = response.data || [];

    // Optional: sort newest first
    const sorted = data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    this.setState({
      issuedInventory: sorted,
      loading: false,
          adjustItem: null,
          adjustType: null,
          adjustQty: '',
          adjustRemarks: '',
          inventoryFilter: "ALL",      
    });

  } catch (err) {
    console.error('Error fetching issued inventory:', err);
    alert('Error fetching issued inventory');
    this.setState({ loading: false });
  }
};


  getBranches = () => {
    api.get(`${process.env.REACT_APP_URL}/branches`)
      .then(response => {
        this.setState({ branches: response.data }, this.getOrgs);
      })
      .catch(error => {
        console.error('Error fetching branches:', error);
      });
  };

  getOrgs = () => {
    api.get(`${process.env.REACT_APP_URL}/orgs`)
      .then(response => {
        this.setState({ orgs: response.data });
      })
      .catch(error => {
        console.error('Error fetching orgs:', error);
      });
  };

  handleFilterChange = (key, value) => {
    this.setState(prevState => ({
      filters: { ...prevState.filters, [key]: value }
    }));
  };

 passesFilter = row => {
  const { filters } = this.state;

  return Object.entries(filters).every(([key, value]) => {
    const rowVal = row[key];
    return (String(rowVal || '')).toLowerCase().includes((value || '').toLowerCase());
  });
};


  toggleModal = (isEditMode = false, service = null, isInventoryItem = true, org = "ReRoot") => {
    console.log("toggleModal ", service, isEditMode);
    this.setState({
      showModal: !this.state.showModal,
      isEditMode,
      newService: {
        name: service?.name || '',
        description: service?.description || '',
        amount: service?.amount || 0,
        qty: service?.qty || 0,
        minQtyAlert: service?.minQtyAlert ?? 3,
        cgst: service?.cgst || 0,
        sgst: service?.sgst || 0,
        igst: service?.igst || 0,
        ecess: service?.ecess || 0,
        remarks: service?.remarks || '',
        isInventoryItem: true,
        //branch: service?.branch || 'selectB',
        //org: service?.org || 'selectOrg',
        branch: !service ? (this.context?.auth?.branch || '') : (service?.branch || 'selectB'),
        //org: isInventoryItem ? 'ReRoot' : (service?.org || 'selectOrg'),
        org: isInventoryItem ? org : (service?.org || 'selectOrg'),
        hsn: service?.hsn || '', // 🆕
        imageUrl: service?.imageUrl || '', // preserve current image for preview
      },
      editServiceId: service?._id || null
    });
  };

  handleEditService = (serviceId, org) => {
    const { services } = this.state;
    const serviceToEdit = services.find(s => s._id === serviceId);
    if (serviceToEdit) {
      this.toggleModal(true, serviceToEdit, true, org);
    }
  };

  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // 🧩 Minimum size check (e.g., 5KB)
    if (file.size < 5 * 1024) {
      alert("Image size too small. Minimum 5KB required.");
      e.target.value = "";
      return;
    }

    this.setState(prev => ({
      newService: { ...prev.newService, image: file }
    }));
  };

updateService = () => {
    const { newService, editServiceId, activeTab } = this.state;

    if (!newService.name) {
      alert('Item Name is required.');
      return;
    }
    if (newService.branch === "selectB" || newService.org === "selectOrg") {
      alert("Please choose a valid branch / Org");
      return;
    }

  const requiredNumbers = ['amount', 'qty', 'cgst', 'sgst'];//, 'igst', 'ecess'];
  
  const emptyFields = requiredNumbers.filter(key => {
      const val = newService[key];
      return val === '' || val === null || isNaN(val);
    });

    if (emptyFields.length > 0) {
      alert(`Please fill valid values for: ${emptyFields.join(', ')}`);
      return;
    }
    const imageFile = newService.image;
    const payload = { ...newService };
    delete payload.image;

    if (imageFile) this.setState({ uploadingImage: true });

    api.post(`${process.env.REACT_APP_URL}/services/update/${editServiceId}`, payload)
      .then(async (response) => {
        // Upload image if a new one was selected
        if (imageFile) {
          const fd = new FormData();
          fd.append('image', imageFile);
          try {
            await api.post(`${process.env.REACT_APP_URL}/services/${editServiceId}/image`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
          } catch (_) {}
        }
        alert("Updated successfully");

        this.setState({
          uploadingImage: false,
          services: this.state.services.map(s => s._id === editServiceId ? { ...newService, _id: editServiceId } : s),
          showModal: false,
          isEditMode: false,
          adjustItem: null,
          adjustType: null,
          adjustQty: '',
          adjustRemarks: '',
          returnDate: "",
          newService: {
            name: '',
            description: '',
            amount: '',
            qty: 1,
            minQtyAlert: 3,
            remarks: '',
            branch: 'selectB',
            org: 'selectOrg',
            igst: 0,
            cgst: 0,
            sgst: 0,
            ecess: 0,
            hsn:""
          },
          editServiceId: null
        });
        this.fetchServices(activeTab);
        this.fetchIssuedInventory();

      })
      .catch(() => {
        this.setState({ uploadingImage: false });
        alert('Error updating service');
      });
  };

  prefilledSelectionCriteria = row => {
    return this.state.selectedRows.some(r => r._id === row._id);
  };

  handleCellChange = (key, id, e) => {
    const value = e.target.value;

    this.setState(prevState => {
      const dataCopy = [...prevState.suggestedServices];
      const idx = dataCopy.findIndex(r => r._id === id);
      if (idx < 0) return null;
      
      const updatedRow = { ...dataCopy[idx], [key]: value };
      dataCopy[idx] = updatedRow;

      const modRows = [...prevState.modRows];
      const modIdx = modRows.findIndex(r => r._id === updatedRow._id);
      if (modIdx >= 0) {
        modRows[modIdx] = updatedRow;
      } else {
        modRows.push(updatedRow);
      }

      const selectedRows = [...prevState.selectedRows];
      const selIdx = selectedRows.findIndex(r => r._id === updatedRow._id);
      if (selIdx >= 0) {
        selectedRows[selIdx] = updatedRow;
      } else {
        selectedRows.push(updatedRow);
      }

      return {
        suggestedServices: dataCopy,
        modRows,
        selectedRows
      };
    }, () => {
      if (this.props.onDataChange) {
        const combinedMap = new Map();
        this.state.modRows.forEach(r => combinedMap.set(r._id, r));
        this.state.selectedRows.forEach(r => combinedMap.set(r._id, r));
        this.props.onDataChange(Array.from(combinedMap.values()));
      }
    });
  };

  handleSeqChange = e => {
    const selectedRows = e.selectedRows;
    this.setState({ selectedRows }, () => {
      const { selectedRows, modRows } = this.state;
      const combinedMap = new Map();
      selectedRows.forEach(r => combinedMap.set(r._id, r));
      modRows.forEach(r => combinedMap.set(r._id, r));
      const combinedRows = Array.from(combinedMap.values());

      if (this.props.onDataChange) {
        this.props.onDataChange(combinedRows);
      }
    });
  };

  handleNewServiceChange = (key, value) => {
    this.setState(prev => ({
      newService: { ...prev.newService, [key]: value }
    }));
  };

  addNewService = () => {
    const { newService, activeTab } = this.state;
    if (!newService.name) {
      alert('Item Name is required.');
      return;
    }
    if (newService.branch === "selectB" || newService.org === "selectOrg") {
      alert("Please choose a valid branch / Org");
      return;
    }
    /*
    if (newService.org != activeTab) {
      alert("Invalid Org Selected");
      return;
    }*/
   newService.org = activeTab;
    
    const isDuplicate = this.state.services.some(service => 
      (service?.hsn && service.hsn === newService.hsn) || service.name === newService.name
    );

    if (isDuplicate) {
      // Duplicate found — do not add
      alert ('HSN or Service already exists.');
      return;
    }
    const imageFile = newService.image;
    const payload = { ...newService };
    delete payload.image; // Don't send File object in JSON

    if (imageFile) this.setState({ uploadingImage: true });

    api.post(`${process.env.REACT_APP_URL}/services/add`, payload)
      .then(async (response) => {
        // Upload image if selected
        if (imageFile && response.data?._id) {
          const fd = new FormData();
          fd.append('image', imageFile);
          try {
            await api.post(`${process.env.REACT_APP_URL}/services/${response.data._id}/image`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
          } catch (_) {}
        }
        alert("Added successfully");

        this.setState({
          uploadingImage: false,
          services: [...this.state.services],
          showModal: false,
          adjustItem: null,
          adjustType: null,
          adjustQty: '',
          adjustRemarks: '',
          returnDate: "",
          newService: {
            name: '',
            description: '',
            amount: '',
            qty: 1,
            minQtyAlert: 3,
            remarks: '',
            branch: 'selectB',
            org: 'selectOrg',
                igst: 0,
            cgst: 0,
            sgst: 0,
            ecess: 0,
            hsn: ""
          }
        });
        this.fetchServices(activeTab);
        this.fetchIssuedInventory();
      })
      .catch(error => { this.setState({ uploadingImage: false }); alert('Error adding: ' + (error?.response?.data?.error || error?.response?.data || error.message || 'Unknown error')); });
  };

getInventoryColumns = () => {
  const services = this.props.services ?? [];

const hasIgst = services.some(row => row.igst != null && row.igst !== 0);
const hasEcess = services.some(row => row.ecess != null && row.ecess !== 0);


  return [
    {
      name: "Image",
      selector: row => row.imageUrl || "",
      width: "80px",
      cell: row => (
        row.imageUrl
          ? <SafeImage src={row.imageUrl} alt="item" style={{ width: 50, height: 50, objectFit: "cover", borderRadius: 4 }} />
          : <span style={{ color: "#999" }}>No image</span>
      )
    },
    {
      name: "Item",
      selector: row => row.name || '',
      sortable: true,
      wrap: true,
      width: "150px"
    },
    {
      name: "HSN",
      selector: row => row.hsn || '',
      sortable: true,
      width: "100px"
    },
      
 {
  name: "In Stock",
  selector: row => row.qtyInStock || 0,
  sortable: true,
  width: "15px",
  cell: row => (
    <div
      style={{
        backgroundColor: (!row.qtyInStock || row.qtyInStock == 0) ? "red" : (row.qtyInStock <= (row.minQtyAlert ?? 3) ? "#fff3cd" :  "transparent"), // light yellow when low
        color: !row.qtyInStock ||row.qtyInStock == 0 ? "black" : (row.qtyInStock < (row.minQtyAlert ?? 3) ? "#b71c1c" :  "inherit"),                // dark red text
        fontWeight: !row.qtyInStock || row.qtyInStock < (row.minQtyAlert ?? 3) ? "bold" : "normal",
        fontSize: '16px',
        textAlign: "center",
        padding: "2px 4px",
        borderRadius: "3px",
        minWidth: "40px"
      }}
    >
      {row.qtyInStock || 0}
    </div>
  )
},

{
      name: "Min Qty Alert",
      selector: row => row.minQtyAlert ?? 3,
      sortable: true,
      width: "100px"
    },
 
/*
{
      name: "Qty for this Price",
      selector: row => row.qty || '',
      sortable: true,
      width: "100px"
    },
 */
    {
      name: "Amount",
      selector: row => row.amount != null ? row.amount : '',
      sortable: true,
      width: "90px"
    },
     {
        name: "Sgst",
        selector: function (row) {
          return row && row.sgst != null ? row.sgst : '';
        },
        sortable: true
      },
      {
        name: "Cgst",
        selector: function (row) {
          return row && row.cgst != null ? row.cgst : '';
        },
        sortable: true
      },
      {
        name: "Igst",
        selector: function (row) {
          return row && row.igst != null ? row.igst : '';
        },
        sortable: true,
        omit: (hasIgst == false),
      },
      {
        name: "ECess",
        selector: function (row) {
          return row && row.ecess != null ? row.ecess : '';
        },
        sortable: true,
        omit: (hasEcess == false),
      },
    /*
    {
      name: "Branch",
      selector: row => row.branch || '',
      sortable: true
    },*/
  {
  name: "Actions",
  sortable: false,
  filterable: false,
  omit: !canDo(this.context?.auth, 'inventory.edit') && !canDo(this.context?.auth, 'inventory.add') && !canDo(this.context?.auth, 'inventory.delete'),
  actions: (row) => [
    ...(canDo(this.context?.auth, 'inventory.edit') ? [{ icon: <FaEdit size={18} color="green" />,   label: "Edit",         desc: "Edit item details",        onClick: () => this.handleEditService(row?._id, row.org) }] : []),
    ...(canDo(this.context?.auth, 'inventory.edit') ? [{ icon: <FaPlus size={18} color="blue" />,    label: "Add Stock",    desc: "Increase stock quantity",   onClick: () => this.openAdjustModal(row, "ADD") }] : []),
    ...(canDo(this.context?.auth, 'inventory.edit') ? [{ icon: <FaMinus size={18} color="orange" />, label: "Remove Stock", desc: "Decrease stock quantity",   onClick: () => this.openAdjustModal(row, "REMOVE") }] : []),
    ...(canDo(this.context?.auth, 'inventory.edit') ? [{ icon: <FaStar size={18} color="purple" />,  label: "Issue / Gift", desc: "Issue or gift this item",  onClick: () => this.openAdjustModal(row, "ISSUE") }] : []),
    ...(canDo(this.context?.auth, 'inventory.delete')
      ? [{ icon: <FaTrash size={18} color="red" />, label: "Delete", desc: "Permanently remove item", onClick: () => this.handleDeleteService(row?._id) }]
      : []),
  ],
  }

  ];
};

getInventoryIssueColumns = () => {
  return [
    {
      name: "Item",
      selector: row => row.service?.name || '',
      sortable: true,
      wrap: true,
      width: "150px"
    },
    {
      name: "HSN",
      selector: row => row.service?.hsn || '',
      sortable: true,
      width: "100px"
    },
      {
      name: "Type",
      selector: row => (row.issueType == "Gift") ? '🎁' : (row.issueType || ''),
      sortable: true,
      width: "100px"
    },
 
    {
      name: "Qty",
      selector: row => (row.qty !== undefined && row.qty !== null) ? row.qty : '',
      sortable: true,
      width: "100px"
    },
     {
      name: "Contact Number",
      selector: row => row.issueDetails.number || '',
      sortable: true,
      width: "100px"
    },
    {
      name: "Name",
      selector: row => row.issueDetails.name || '',
      sortable: true,
      width: "100px"
    },
    {
      name: "Issued When",
      selector: row => row.issueDetails.issuedWhen || '',
      sortable: true,
      width: "100px"
    },
  {
  name: "ETA Return Date",
  selector: row => {
    if (!row.issueDetails.etaDate) return '';
    const date = new Date(row.issueDetails.etaDate);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yy = String(date.getFullYear()).slice(-2);
    return `${dd}-${mm}-${yy}`;
  },
  sortable: true,
  width: "100px"
},

   {
  name: "Actual Return Date",
  selector: row => {
    if (!row.issueDetails.returnDate) return '';
    const date = new Date(row.issueDetails.returnDate);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yy = String(date.getFullYear()).slice(-2);
    return `${dd}-${mm}-${yy}`;
  },
  sortable: true,
  width: "100px"
},

   {
      name: "Remarks",
      selector: row => row.issueDetails.remarks || '',
      sortable: true,
      width: "100px"
    },
    
   {
      name: "Org",
      selector: row => row.service?.org || '',
      sortable: true,
      wrap: true,
      width: "100px"
    },
  {
  name: "Actions",
  sortable: false,
  filterable: false,
  actions: (row) => [
    ...(row.issueType !== "Gift" && row.qty > 0
      ? [{ icon: <FaThumbsUp size={18} color="black" />, label: "Return", desc: "Return this issued item", onClick: () => this.openAdjustModal(row, "RETURN") }]
      : []),
    ...(canDo(this.context?.auth, 'inventory.delete')
      ? [{ icon: <FaTrash size={18} color="red" />, label: "Delete", desc: "Remove this record", onClick: () => this.handleDeleteIssuedInventory(row?._id) }]
      : []),
  ],
}

  ];
};

getFilteredServices = () => {
  const { inventoryFilter } = this.state;
  const services = this.state.services ?? [];

  const userBranch = this.context?.auth?.branch || '';
  const superUser = isSuper(this.context?.auth);
  // Owner/solution see all branches; others filtered to their branch (or all if no branch set)
  const orgData = (superUser || !userBranch)
    ? services.filter(s => s.org === "ReRoot")
    : services.filter(s => s.org === "ReRoot" && s.branch === userBranch);

  if (inventoryFilter === "LOW_STOCK") {
    return orgData.filter(s => s.qtyInStock <= s.minQtyAlert);
  }

  if (inventoryFilter === "PO_RAISED") {
    return orgData.filter(s => s.poRaised);
  }

  return orgData;
};

handleDeleteService = (id) => {
 const { activeTab } = this.state;
  if (window.confirm("Are you sure you want to delete this service?")) {
    api.delete(`${process.env.REACT_APP_URL}/services/delete/${id}`)
      .then(() => {
        this.setState(prev => ({
          services: prev.services.filter(s => s._id !== id)
        }));
        alert("Service deleted successfully");
        this.fetchServices(activeTab);
        this.fetchIssuedInventory();
      })
      .catch(() => {
        alert("Error deleting service");
      });
  }
};


handleDeleteIssuedInventory = (id) => {
  const { activeTab } = this.state;
  if (window.confirm("Are you sure you want to delete this?")) {
    api.delete(`${process.env.REACT_APP_URL}/services/issuedInventory/delete/${id}`)
      .then(() => {
        this.setState(prev => ({
          services: prev.services.filter(s => s._id !== id)
        }));
        alert("Deleted successfully");
        this.fetchServices(activeTab);
        this.fetchIssuedInventory();
      })
      .catch(() => {
        alert("Error deleting");
      });
  }
};

openAdjustModal = (item, type) => {

 const today = new Date();
  const returnDate = new Date(today);
  returnDate.setDate(returnDate.getDate() + 7);

  const formattedReturnDate = returnDate.toISOString().split("T")[0];
  const formattedToday = today.toISOString().split("T")[0];


  let stateUpdate = {
    editServiceId: item._id,
    showAdjustModal: true,
    adjustItem: item,
    adjustType: type,
    //etaDate: "",
    name: item.name,
    adjustRemarks: '',
    issueType: type === "ISSUE" ? "Issue" : type,
    returnDate: "",//formattedToday,    
    etaDate: type != "RETURN" ? formattedReturnDate: formattedToday,
    //adjustQty: 1,                      // ✅ default quantity = 1
    //maxQty: type == "ISSUE" ? (item.stockInQty || 1) : 20,      // ✅ prevent undefined
  };

   // Only prefill name/number for RETURN or ISSUE
  if (type === "RETURN" || type === "ISSUE") {
    stateUpdate.name = item.issueDetails?.name || "";
    stateUpdate.number = item.issueDetails?.number || "";
    if (type == "RETURN")
    {      
      item._id = stateUpdate.editServiceId = item.serviceId;
    }
  }

  this.setState(stateUpdate);
};

/*
openAdjustModal = (item, type) => {
  this.setState({
    editServiceId: item._id,
    showAdjustModal: true,
    adjustItem: item,
    adjustType: type,
    adjustQty: '',
    etaDate: "",
    returnDate: "",
    adjustRemarks: '',
    name: type === "RETURN" ? item.issueDetails?.name || "" : "",
    number: type === "RETURN" ? item.issueDetails?.number || "" : "",
    issueType: "Issue"  // default to Issue on modal open
  });
};
*/

confirmAdjustStock = () => {
  const { adjustItem, adjustType, adjustQty, adjustRemarks, 
          returnDate, name, number, etaDate, issueType, activeTab } = this.state;
  let { editServiceId } = this.state;

  const qtyNum = parseFloat(adjustQty);
  if (isNaN(qtyNum) || qtyNum <= 0) {
    alert("Please enter a valid quantity.");
    return;
  }

  const change = (adjustType === "ADD" || adjustType === "RETURN") ? qtyNum : -qtyNum;
  const currentStock = Number(adjustItem.qtyInStock) || 0;

  if (adjustType === "ISSUE") {
    // Check stock availability before issuing
    if (qtyNum > currentStock) {
      alert(`Cannot issue ${qtyNum}. Only ${currentStock} in stock.`);
      return;
    }
    if (!name || !number) {
      alert("Please fill the missing Name and Number.");
      return;
    }
    // Only require etaDate if issueType is NOT Gift
    if (issueType !== "Gift" && !etaDate) {
      alert("Please fill the missing ETA Return Date.");
      return;
    }
  } else if (adjustType === "RETURN") {
    if (!name || !number) {
      alert("Please fill the missing Name and Number.");
      return;
    }
    if (adjustItem.qty < change) {
      alert(`Max qty to return = ${adjustItem.qty}`);
      return;
    }
    editServiceId = adjustItem._id;
  } else if (change + currentStock < 0) {
    // ADD/REMOVE — stock cannot go negative
    alert('Error: Stock Adjustment cannot be Negative.');
    return;
  }
  api.post(`${process.env.REACT_APP_URL}/services/update/${editServiceId}`, {
    itemId: adjustItem._id,
    change: change,
    type: adjustType,
    remarks: adjustRemarks,
    returnDate: returnDate,
    etaDate: etaDate,
    name: name,
    number: number,
    issueType: issueType  // send issueType for backend awareness if needed
  })
  .then(() => {
    alert("Stock adjusted successfully.");
    this.setState({ showAdjustModal: false });
    this.fetchServices(activeTab);
    this.fetchIssuedInventory();
  })
  .catch(() => alert("Error adjusting stock"));
};


  render() {
    const { patientCard } = this.props;
    const auth = this.context.auth;
    console.log("auth context = ", this.context)
    const {
      suggestedServices,
      services,
      issuedInventory,
      filters,
      showModal,
      newService,
      branches,
      orgs,
      activeTab,
      isEditMode
    } = this.state;

    const rowsToShow = (suggestedServices || [])
      .filter(this.passesFilter)
      .sort((a, b) => {
        return (a.parentId && a.parentId !== '' ? 0 : 1) - (b.parentId && b.parentId !== '' ? 0 : 1);
      });

    return (
      <div>
        {this.state.uploadingImage && (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
            <div style={{ background: '#fff', padding: '24px 36px', borderRadius: 12, textAlign: 'center', boxShadow: '0 4px 20px rgba(0,0,0,0.2)' }}>
              <div style={{ width: 36, height: 36, border: '4px solid #e2e8f0', borderTopColor: '#4f46e5', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 12px' }} />
              <div style={{ fontWeight: 600, color: '#374151' }}>Uploading image to Drive...</div>
            </div>
          </div>
        )}
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        <div className="inv-page-header">📦 Inventory</div>
    

     {/* ---------- TABS ---------- */}
      <div style={{ marginBottom: "20px", padding: "10px 0", display: "flex", gap: 10 }}>
        <button
          onClick={() => this.setState({ activeTab: "ReRoot" }, () => { this.fetchServices("ReRoot"); })}
          className={activeTab === "ReRoot" ? "tab-active" : "tab"}
        >
          🏥 ReRoot Inventory
        </button>
        <button
          onClick={() => this.setState({ activeTab: "MedicalyogaTherapyCentre" }, () => { this.fetchServices("MedicalyogaTherapyCentre"); })}
          className={activeTab === "MedicalyogaTherapyCentre" ? "tab-active" : "tab"}
        >
          🧘 MYC Inventory
        </button>
      </div>
        {activeTab === "ReRoot" && (() => {
          const ub = this.context?.auth?.branch || '';
          const su = isSuper(this.context?.auth);
          const orgItems = (su || !ub)
            ? services.filter(s => s.org === "ReRoot")
            : services.filter(s => s.org === "ReRoot" && s.branch === ub);
          return <>
              <div className="dashboard-summary">
              {[
                { label: "Total Items",  count: orgItems.length,                                        filter: "ALL",       variant: "late",      icon: "📦" },
                { label: "Low Stock",    count: orgItems.filter(s => s.qtyInStock <= s.minQtyAlert).length, filter: "LOW_STOCK",  variant: "missed",    icon: "⚠️" },
                { label: "PO Raised",    count: orgItems.filter(s => s.poRaised).length,                filter: "PO_RAISED", variant: "inprogress", icon: "📋" },
              ].map(card => (
                <div
                  key={card.label}
                  onClick={() =>
                    this.setState({
                      inventoryFilter:
                        this.state.inventoryFilter === card.filter ? "ALL" : card.filter,
                    })
                  }
                  className={`summary-card ${card.variant} clickable${this.state.inventoryFilter === card.filter ? " selected" : ""}`}
                >
                  <div className="card-icon">{card.icon}</div>
                  <div className="card-count">{card.count}</div>
                  <div className="card-label">{card.label}</div>
                </div>
              ))}
              </div>
              <button onClick={() => this.toggleModal(false, null, true, activeTab)} className="cta-btn">
                ➕ Add Inventory Item
              </button>

              <CustomDataTable
                columns={this.getInventoryColumns()}
                data={this.getFilteredServices()}//services.filter(s => s.org === "ReRoot" && s.branch === "PunjabiBagh"))}
                paginationPerPage={100}
                highlightOnHover
                conditionalRowStyles={[
                  {
                    when: row => row.qty <= row.minQtyAlert,
                    style: {
                      backgroundColor: "#fff3cd",
                      borderColor: "#b71c1c",
                    }
                  }
                ]}
              />
          </>
        })()}
        {activeTab === "MedicalyogaTherapyCentre" && (
           <>
            <button onClick={() => this.toggleModal(false, null, true, activeTab)} className="cta-btn">
              ➕ Add MYC Item
            </button>
          
            <CustomDataTable
              columns={this.getInventoryColumns()}
              data={services.filter(s => {
                const ub = this.context?.auth?.branch || '';
                const su = isSuper(this.context?.auth);
                return s.org === activeTab && s.isInventoryItem == true && (su || !ub || s.branch === ub);
              })}
              paginationPerPage={100}
              highlightOnHover
              conditionalRowStyles={[
                {
                  when: row => row.qty < 4,
                  style: {
                    backgroundColor: "#fff3cd",
                    color: "#b71c1c",
                  }
                }
              ]}
            />
          </>
        )}


        <div className="inv-issued-header">🎁 Issued / Gifted</div>

        <CustomDataTable
          columns={this.getInventoryIssueColumns()}
          data={issuedInventory}
          paginationPerPage={100}
          highlightOnHover       
        />

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content wide" style={{ display: 'flex', flexDirection: 'column' }}>
            <button className="close-btn" onClick={() => this.toggleModal(false, null, true)}>✕</button>
            <h4 style={{ marginTop: 0, marginBottom: '20px' }}>
              {isEditMode ? '✏️ Edit Item' : '➕ Add New Item'}
            </h4>

            <div className="modal-form-grid">
              <div className="modal-form-field">
                <label>Branch</label>
                <select value={newService.branch} onChange={e => this.handleNewServiceChange('branch', e.target.value)}>
                  <option value="selectB">Select Branch</option>
                  {branches.filter(b => b.isActive !== false && b.status !== 'inactive').map(branch => (
                    <option key={branch.name} value={branch.name}>{branch.name}</option>
                  ))}
                </select>
              </div>

              <div className="modal-form-field">
                <label>Org</label>
                <select value={newService.org} onChange={e => this.handleNewServiceChange('org', e.target.value)}>
                  <option value="selectOrg">Select Org</option>
                  {orgs.map(org => (
                    <option key={org.name} value={org.name}>{org.name}</option>
                  ))}
                </select>
              </div>

              <div className="modal-form-field">
                <label>Item Name</label>
                <input value={newService.name} onChange={e => this.handleNewServiceChange('name', e.target.value)} />
              </div>

              <div className="modal-form-field">
                <label>Description</label>
                <textarea value={newService.description} onChange={e => this.handleNewServiceChange('description', e.target.value)} />
              </div>

              <div className="modal-form-field">
                <label>Amount (₹)</label>
                <input value={newService.amount} onChange={e => this.handleNewServiceChange('amount', e.target.value)} type="number" />
              </div>

              <div className="modal-form-field">
                <label>Quantity For this Price</label>
                <input value={newService.qty} onChange={e => this.handleNewServiceChange('qty', Math.max(1, parseInt(e.target.value) || 1))} type="number" min={1} />
              </div>

              <div className="modal-form-field">
                <label>Min Qty Alert</label>
                <input value={newService.minQtyAlert} onChange={e => this.handleNewServiceChange('minQtyAlert', Number(e.target.value))} type="number" min="0" />
              </div>

              {this.state.isInventoryItem && (
                <div className="modal-form-field">
                  <label>HSN Code</label>
                  <input type="text" value={newService.hsn} onChange={e => this.handleNewServiceChange('hsn', e.target.value)} />
                </div>
              )}

              <div className="modal-form-field">
                <label>CGST (%)</label>
                <input value={newService.cgst} onChange={e => this.handleNewServiceChange('cgst', e.target.value)} type="number" />
              </div>

              <div className="modal-form-field">
                <label>SGST (%)</label>
                <input value={newService.sgst} onChange={e => this.handleNewServiceChange('sgst', e.target.value)} type="number" />
              </div>

              <div className="modal-form-field">
                <label>IGST (%)</label>
                <input value={newService.igst} onChange={e => this.handleNewServiceChange('igst', e.target.value)} type="number" />
              </div>

              <div className="modal-form-field">
                <label>ECess (%)</label>
                <input value={newService.ecess} onChange={e => this.handleNewServiceChange('ecess', e.target.value)} type="number" />
              </div>

              <div className="modal-form-field">
                <label>Upload Image</label>
                {isEditMode && newService.imageUrl && !newService.image && (
                  <div style={{ marginBottom: 8 }}>
                    <img src={newService.imageUrl} alt="Current" style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 6, border: '1px solid #e2e8f0' }} />
                    <div style={{ fontSize: 11, color: '#6b7280', marginTop: 4 }}>Current image — select a new file below to replace</div>
                  </div>
                )}
                <input type="file" accept="image/*" onChange={this.handleFileChange} />
              </div>

              <div className="modal-form-field">
                <label>Remarks</label>
                <textarea value={newService.remarks} onChange={e => this.handleNewServiceChange('remarks', e.target.value)} />
              </div>
            </div>

            <div className="modal-actions">
              <button className="modal-btn-cancel" onClick={() => this.toggleModal(false, null, true)}>
                Cancel
              </button>
              <button onClick={isEditMode ? this.updateService : this.addNewService}>
                {isEditMode ? '✏️ Update' : '➕ Add'} Item
              </button>
            </div>
          </div>
        </div>
      )}

      {this.state.showAdjustModal && (
        <div className="modal-overlay" style={{ zIndex: 2000 }}>
          <div className="modal-content">
            <button className="close-btn" onClick={() => this.setState({ showAdjustModal: false })}>✕</button>
            <h4 style={{ marginTop: 0 }}>
              {this.state.adjustType === "ADD" ? "➕" : this.state.adjustType === "REMOVE" ? "➖" : this.state.adjustType === "ISSUE" ? "📤" : "📥"}{" "}
              {this.state.adjustType} Stock
            </h4>
            <p style={{ color: "#555", fontSize: 14, marginBottom: 16 }}>
              <strong>Item:</strong> {this.state.adjustItem?.name}
            </p>

            <div className="modal-form-grid" style={{ gap: 12 }}>
              {this.state.adjustType === "ISSUE" && (
                <>
                  <div className="modal-form-field">
                    <label>Issue Type</label>
                    <select value={this.state.issueType || "Issue"} onChange={e => this.setState({ issueType: e.target.value })}>
                      <option value="Issue">Issue</option>
                      <option value="Gift">Gift</option>
                    </select>
                  </div>
                  {this.state.issueType !== "Gift" && (
                    <div className="modal-form-field">
                      <label>Estimated Return Date</label>
                      <input type="date" value={this.state.etaDate} onChange={(e) => this.setState({ etaDate: e.target.value })} />
                    </div>
                  )}
                </>
              )}

              <div className="modal-form-field" style={{ flex: '1 1 100%' }}>
                <label>Quantity</label>
                <input type="number" value={this.state.adjustQty} onChange={e => this.setState({ adjustQty: e.target.value })} />
              </div>

              {["ISSUE", "RETURN"].includes(this.state.adjustType) && (
                <>
                  <div style={{ flex: '1 1 100%', paddingTop: 10, borderTop: '1px solid #eee' }}>
                    <p style={{ fontWeight: 700, fontSize: 13, color: '#1a1d23', margin: '0 0 10px' }}>👤 Person's Details</p>
                  </div>
                  {this.state.activeTab === "ReRoot" ? (
                    <>
                      <div className="modal-form-field">
                        <label>Name</label>
                        <input
                          type="text"
                          value={this.state.name}
                          onChange={this.state.adjustType === "ISSUE" ? (e) => this.setState({ name: e.target.value }) : undefined}
                          disabled={this.state.adjustType === "RETURN"}
                        />
                      </div>
                      <div className="modal-form-field">
                        <label>Contact Number</label>
                        <input
                          type="number"
                          maxLength={10}
                          value={this.state.number}
                          onChange={this.state.adjustType === "ISSUE" ? (e) => this.setState({ number: e.target.value }) : undefined}
                          disabled={this.state.adjustType === "RETURN"}
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="modal-form-field">
                        <label>Select Name</label>
                        <select
                          value={this.state.name || 'selectT'}
                          onChange={(e) => {
                            const name = e.target.value;
                            const user = this.state.users.find(u => u.username === name);
                            this.setState({ name, number: user?.number || "" });
                          }}
                          disabled={this.state.adjustType === "RETURN"}
                        >
                          <option value="selectT">Select</option>
                          {this.state.users.map(t => (
                            <option key={t.username} value={t.username}>{t.username}</option>
                          ))}
                        </select>
                      </div>
                      <div className="modal-form-field">
                        <label>Contact Number</label>
                        <input type="number" maxLength={10} value={this.state.number} readOnly />
                      </div>
                    </>
                  )}
                </>
              )}

              <div className="modal-form-field" style={{ flex: '1 1 100%' }}>
                <label>Remarks</label>
                <textarea value={this.state.adjustRemarks} onChange={e => this.setState({ adjustRemarks: e.target.value })} />
              </div>
            </div>

            <div className="modal-actions">
              <button className="modal-btn-cancel" onClick={() => this.setState({ showAdjustModal: false })}>
                Cancel
              </button>
              <button onClick={this.confirmAdjustStock}>
                ✅ Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      </div>
    );
  }
}

export default Inventory;
